"use client"

import { useFrontendPreferences } from "@lib/frontend-preferences"

export default function CatalogHeader() {
  const { t } = useFrontendPreferences()

  return (
    <div className="sahil-catalog__heading">
      <p>{t.catalog.eyebrow}</p>
      <h1 data-testid="store-page-title">{t.catalog.title}</h1>
      <span>{t.catalog.body}</span>
    </div>
  )
}
